import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';
import type {
    FuzzyMatchImportColumnsInput,
    FuzzyMatchImportColumnsResponse,
} from '../functions/import/fuzzyColumnMatch';

const fuzzyMatchImportColumns = async (
    sessionId: string,
    input: FuzzyMatchImportColumnsInput,
): Promise<FuzzyMatchImportColumnsResponse> => {
    const { data } = await axios.post(`${API_URL}/import/fuzzy-match`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useFuzzyMatchImportColumns = (
    options?: UseMutationOptions<
        FuzzyMatchImportColumnsResponse,
        unknown,
        FuzzyMatchImportColumnsInput
    >,
) => {
    const sessionContext = useContext(SessionContext);
    return useMutation({
        mutationFn: (input: FuzzyMatchImportColumnsInput) =>
            fuzzyMatchImportColumns(sessionContext?.sessionId ?? '', input),
        ...options,
    });
};
